import random from 'lodash/random';

interface AttrType {
    firstRow: string;
    secondRow: string;
    thirdRow: string;
}

interface ImagesWithAttrType {
    imageBgClass: string;
    attribution: AttrType;
}

export const AVAILABLE_IMAGES: ImagesWithAttrType[] = [
    {
        imageBgClass: 'split-container__bg-1',
        attribution: {
            firstRow: 'Trap Yoga Bae',
            secondRow: 'Trap Yoga Brooklyn',
            thirdRow: 'Brooklyn, NY',
        },
    },
    {
        imageBgClass: 'split-container__bg-2',
        attribution: {
            firstRow: 'Hungry Pop',
            secondRow: 'Kesté',
            thirdRow: 'New York, NY',
        },
    },
    {
        imageBgClass: 'split-container__bg-3',
        attribution: {
            firstRow: 'Winston Baker',
            secondRow: 'Confluence Summit',
            thirdRow: 'San Francisco, CA',
        },
    },
];

export const getRandomImage = () => {
    const randomValue = random(0, AVAILABLE_IMAGES.length - 1);
    const imageWithAttribution = AVAILABLE_IMAGES[randomValue];

    return imageWithAttribution;
};
